import { ResourceRecorder } from '../src/ResourceRecorder';

export const globalMacrosCSSRecorder = new ResourceRecorder();
export const globalMacrosJSRecorder = new ResourceRecorder();
